/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BackOfficeApiKeyLookupRequest
 */
export interface BackOfficeApiKeyLookupRequest {
    /**
     * 
     * @type {string}
     * @memberof BackOfficeApiKeyLookupRequest
     */
    encodedKey: string;
}

/**
 * Check if a given object implements the BackOfficeApiKeyLookupRequest interface.
 */
export function instanceOfBackOfficeApiKeyLookupRequest(value: object): value is BackOfficeApiKeyLookupRequest {
    if (!('encodedKey' in value) || value['encodedKey'] === undefined) return false;
    return true;
}

export function BackOfficeApiKeyLookupRequestFromJSON(json: any): BackOfficeApiKeyLookupRequest {
    return BackOfficeApiKeyLookupRequestFromJSONTyped(json, false);
}

export function BackOfficeApiKeyLookupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BackOfficeApiKeyLookupRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'encodedKey': json['encodedKey'],
    };
}

export function BackOfficeApiKeyLookupRequestToJSON(value?: BackOfficeApiKeyLookupRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'encodedKey': value['encodedKey'],
    };
}

